const modules = import.meta.glob('/Vue/**/*.vue');

import $ from 'jquery';
import {createApp} from 'vue';
import {makeGlobalStore} from 'Common/Logical/GlobalStore.js';

import Http from './Http.js'

import 'froala-editor/js/plugins.pkgd.min.js';
import VueFroalaModule from 'vue-froala-wysiwyg';

// vue-froala-wysiwyg ships CJS in its `module` field; depending on bundler interop the
// default import can arrive as the plugin object or as `{ default: plugin }`.
const VueFroala = VueFroalaModule?.install ? VueFroalaModule : VueFroalaModule?.default;

function mount(vueComponent, el, props) {
    const vueApp = createApp(vueComponent, props);
    vueApp.config.devtools = import.meta.env.DEV;
    vueApp.config.performance = import.meta.env.DEV;
    // Register under a dedicated key, not vuex's default 'store', so component-level stores
    // (each installed via app.use(...) in their own setup()) own the default key without a
    // double-provide warning. Nothing injects the global store — it's read via JSVars.VueBus.store.
    vueApp.use(makeGlobalStore(), 'globalStore');
    vueApp.use(Http);
    vueApp.use(VueFroala);
    vueApp.mount(el);
    return vueApp;
}

export default async function mountVueApp(vueComponentName, el, props = {}) {
    if (typeof el === 'string') {
        el = $(el).get(0);
    }

    if (!vueComponentName.endsWith('.vue')) {
        vueComponentName += '.vue';
    }

    try {
        const importer = modules[`/${vueComponentName}`];
        if (!importer) {
            throw new Error(`Vue component at ${vueComponentName} not found in module map`);
        }
        const tryLoad = async (fn) => {
            try {
                return await fn();
            } catch (e) {
                if (/Loading chunk|Failed to fetch dynamically imported module/i.test(e?.message || '')) {
                    if (!sessionStorage.getItem('__chunk_reload')) {
                        sessionStorage.setItem('__chunk_reload', '1');
                        window.location.reload();
                    }
                }
                return null;
            }
        };

        let module = (await tryLoad(importer)) || (await tryLoad(importer));
        if (!module) {
            // Gracefully handle component load failure
            // Prevents unhandled rejections for users with restricted networks
            console.warn(`Component ${vueComponentName} failed to load`);
            return null; // Let the mount point render empty rather than throwing
        }
        const component = module.default ?? module;
        if (!component || typeof component !== 'object') {
            throw new Error(`Vue component at ${vueComponentName} has no default export`);
        }
        return mount(component, el, props);
    } catch (e) {
        console.error(`Could not load Vue component ${vueComponentName}: ${e}`);
        throw e;
    }
}
